<template lang="pug">
  #app
    nav
      router-link(to="/" class="font-semibold my-4 text-xl tracking-tight text-white mr-6") Krystal Looking Glass
      div.navItems
        div(class="text-sm lg:flex-grow")
          router-link(to="/echo" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") Ping
          router-link(to="/traceroute" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") Traceroute
          router-link(to="/whois" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") WHOIS
          router-link(to="/dns" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") DNS
          router-link(to="/reverse_dns" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") Reverse DNS
          router-link(to="/bgp" class="block mt-4 lg:inline-block lg:mt-0 text-purple-200 hover:text-white mr-4") BGP Routes
      div.flex.items-center.flex-shrink.flex-wrap.justify-center
        IPAddress
        HostSelector
    .p-6
      router-view
</template>
<style lang="postcss">
nav {
  @apply flex items-center justify-between flex-wrap px-6;
  background-color: #5e26a0;
}

.navItems {
  @apply hidden block flex-grow;
  display: none;
}

@media (min-width: 1100px) {
  .navItems {
    @apply visible flex items-center w-auto;
  }
}

.heading {
  @apply text-3xl;
}

.subtitle {
  @apply text-gray-700;
}

.button {
  @apply bg-blue-500 mt-6 text-white py-1 px-2 rounded cursor-pointer;
}
.button:hover {
  @apply bg-blue-700;
}
label {
  @apply block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2;
}
input[type="text"] {
  @apply appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight;
}
input[type="text"]:focus {
  @apply outline-none bg-white border-gray-500;
}
</style>
<script>
import HostSelector from "@/components/HostSelector";
import IPAddress from "@/components/IPAddress";

export default {
  components: {
    HostSelector: HostSelector,
    IPAddress: IPAddress,
  },
};
</script>
